"use client";

import "@ant-design/v5-patch-for-react-19";

import { ConfigProvider, theme } from "antd";
import ruRU from "antd/locale/ru_RU";
import { useTheme } from "next-themes";
import { ReactNode } from "react";

const AntThemeProvider = ({ children, defaultTheme }: { defaultTheme: string; children: ReactNode }) => {
    // const [isMounted, setMounted] = useState<boolean>(false);
    // useEffect(() => {
    // setMounted(true);
    // });

    const { resolvedTheme: passedTheme } = useTheme();
    const { defaultAlgorithm, darkAlgorithm } = theme;
    const currentTheme = passedTheme ?? defaultTheme;
    // console.log(passedTheme, systemTheme, currentTheme);

    // const isMounted = true;
    // const currentTheme = "light";

    return (
        <ConfigProvider
        locale={ruRU}
            theme={{
                cssVar: true,
                algorithm: ["dark", "night"].includes(currentTheme) ? darkAlgorithm : defaultAlgorithm,
            }}
        >
            {children}
        </ConfigProvider>
    );
};

export default AntThemeProvider;
